import { rosterSettingsSchema } from './schema';
import RosterSettingsFormContent from './RosterSettingsFormContent';
import { useUpdateResource } from 'RestAPIs/useUpdateResource';
import { ADMIN_SETTINGS_GROUP } from 'RestAPIs/endpoints';
import { AdminSettingsFormWrapper } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';
import { useGetAdminSettings } from '../../../../../queries';
import { AdminSettingsResponse, Setting } from '../../../../types';

export const convertToSettingsPayload = (
  data: AdminSettingsResponse,
  newData: Setting[]
) => {
  return { ...data[0], settings: newData };
};

const RosterSettings = () => {
  const { data: dlcData = [], isFetching: isFetchingDlc } =
    useGetAdminSettings<AdminSettingsResponse>('duty-line-calculation');
  const { data: ddcData = [], isFetching: isFetchingDdc } =
    useGetAdminSettings<AdminSettingsResponse>('decentralized-dutycodes');
  const { data: dvData = [], isFetching: isFetchingDv } =
    useGetAdminSettings<AdminSettingsResponse>('default-values');

  const { mutateAsync: saveDlc, isLoading: isLoadingDlc } = useUpdateResource({
    url: ADMIN_SETTINGS_GROUP,
    id: dlcData[0]?.groupId,
    invalidateQueryKey: ['duty-line-calculation']
  });
  const { mutateAsync: saveDdc, isLoading: isLoadingDdc } = useUpdateResource({
    url: ADMIN_SETTINGS_GROUP,
    id: ddcData[0]?.groupId ?? '',
    invalidateQueryKey: ['decentralized-dutycodes']
  });
  const { mutateAsync: saveDr, isLoading: isLoadingDr } = useUpdateResource({
    url: ADMIN_SETTINGS_GROUP,
    id: dvData[0]?.groupId,
    invalidateQueryKey: ['default-values']
  });

  const settings =
    isFetchingDlc || isFetchingDdc || isFetchingDv
      ? undefined
      : {
          dutyLineCalculationSchema: [
            {
              ...dlcData[0].settings[0],
              value: JSON.parse(dlcData[0].settings[0].value)
            }
          ],
          decentralizedDutycodesSchema: [
            {
              ...ddcData[0].settings[0],
              value: JSON.parse(ddcData[0].settings[0].value)
            }
          ],
          defaultValuesSchema: [
            {
              ...dvData[0].settings[0]
            }
          ]
        };

  const submitForm = (data) => {
    const dlcPayload = convertToSettingsPayload(
      dlcData,
      data.dutyLineCalculationSchema
    );
    const ddcPayload = convertToSettingsPayload(
      ddcData,
      data.decentralizedDutycodesSchema
    );
    const drPayload = convertToSettingsPayload(
      dvData,
      data.defaultValuesSchema
    );
    Promise.all([saveDlc(dlcPayload), saveDdc(ddcPayload), saveDr(drPayload)]);
  };

  return (
    <AdminSettingsFormWrapper
      submitForm={submitForm}
      schema={rosterSettingsSchema}
      isFetching={isFetchingDlc || isFetchingDdc || isFetchingDv}
      isLoading={isLoadingDlc || isLoadingDdc || isLoadingDr}
      data={settings}
    >
      <RosterSettingsFormContent />
    </AdminSettingsFormWrapper>
  );
};

export default RosterSettings;
